import {BehaviorSubject, Subject} from "rxjs";
import {ReportLog} from "./ReportLog";

export class LogItem {
    log: ReportLog;
    logSubject: Subject<ReportLog>;

    constructor(log: ReportLog) {
        this.log = log;
        this.logSubject = new BehaviorSubject(log);
    }
}